'use client';


import { createIcon } from "../utils/createIcon.js";
import "react";
import { jsx } from "react/jsx-runtime";

//#region src/icons/UserIcon.tsx
const UserIcon = createIcon({
	displayName: "UserIcon",
	viewBox: "0 0 16 16",
	fill: "none",
	path: /* @__PURE__ */ jsx("path", {
		d: "M13.2 14.6c0-.93 0-1.396-.115-1.774a2.667 2.667 0 00-1.778-1.778c-.378-.115-.843-.115-1.774-.115H6.2c-.93 0-1.395 0-1.774.115a2.667 2.667 0 00-1.778 1.778c-.115.378-.115.843-.115 1.774m8.334-9a3 3 0 11-6 0 3 3 0 016 0z",
		stroke: "currentColor",
		strokeWidth: 1.2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
var UserIcon_default = UserIcon;

//#endregion
export { UserIcon_default as default };
//# sourceMappingURL=UserIcon.js.map